function loadSlideshowProduct(sectionId){
    var sectionSelector = '#shopify-section-' + sectionId;
    var carouselSelector = '#owl-carousel-' + sectionId;
    var maxInitAttempts = 40;
    var initAttempts = 0;
    var initTimeoutId = null;

    window.mmProductSlideshowHandlers = window.mmProductSlideshowHandlers || {};

    if (window.mmProductSlideshowHandlers[sectionId]) {
        window.mmProductSlideshowHandlers[sectionId].teardown();
    }

    function getSectionRoot(root) {
        if (root && root.matches && root.matches(sectionSelector)) {
            return root;
        }

        if (root && root.querySelector) {
            return root.querySelector(sectionSelector);
        }

        return document.querySelector(sectionSelector);
    }

    function getCarouselElement(root) {
        var sectionRoot = getSectionRoot(root || document);

        if (sectionRoot) {
            return sectionRoot.querySelector(carouselSelector);
        }

        return document.querySelector(carouselSelector);
    }

    function syncCarouselHeights(carouselElement) {
        var cards = carouselElement.querySelectorAll('.owl-item');
        var maxHeight = 0;

        if (!cards.length) {
            return;
        }

        cards.forEach(function (card) {
            card.style.height = '';
        });

        cards.forEach(function (card) {
            maxHeight = Math.max(maxHeight, card.offsetHeight);
        });

        if (!maxHeight) {
            return;
        }

        cards.forEach(function (card) {
            card.style.height = maxHeight + 'px';
        });
    }

    function queueHeightSync(carouselElement) {
        window.requestAnimationFrame(function () {
            syncCarouselHeights(carouselElement);
        });
    }

    function bindImageListeners(carouselElement) {
        var images = carouselElement.querySelectorAll('img');

        images.forEach(function (image) {
            if (image.dataset.mmSlideshowBound === 'true') {
                return;
            }

            image.dataset.mmSlideshowBound = 'true';

            if (image.complete) {
                return;
            }

            image.addEventListener(
                'load',
                function () {
                    queueHeightSync(carouselElement);
                },
                { once: true }
            );

            image.addEventListener(
                'error',
                function () {
                    queueHeightSync(carouselElement);
                },
                { once: true }
            );
        });
    }

    function scheduleInit(root) {
        if (initTimeoutId || initAttempts >= maxInitAttempts) {
            return;
        }

        initTimeoutId = window.setTimeout(function () {
            initTimeoutId = null;
            initAttempts += 1;
            initCarousel(root || document);
        }, 120);
    }

    function initCarousel(root) {
        var carouselElement = getCarouselElement(root || document);
        var jquery = window.jQuery;
        var owl;

        if (!carouselElement) {
            return;
        }

        bindImageListeners(carouselElement);

        if (!jquery || !jquery.fn || typeof jquery.fn.owlCarousel !== 'function') {
            scheduleInit(root);
            return;
        }

        owl = jquery(carouselElement);

        if (owl.hasClass('owl-loaded')) {
            queueHeightSync(carouselElement);
            return;
        }

        owl.on(
            'initialized.owl.carousel refreshed.owl.carousel resized.owl.carousel',
            function () {
                queueHeightSync(carouselElement);
            }
        );

        owl.owlCarousel({
            nav: true,
            autoWidth: true,
            items: 5,
            margin: 12,
            dots: false,
        });

        queueHeightSync(carouselElement);
    }

    function handleSectionLoad(event) {
        var sectionRoot = getSectionRoot(event.target);

        if (!sectionRoot) {
            return;
        }

        initAttempts = 0;
        initCarousel(sectionRoot);
    }

    function handleResize() {
        var carouselElement = getCarouselElement(document);

        if (!carouselElement || !carouselElement.classList.contains('owl-loaded')) {
            return;
        }

        queueHeightSync(carouselElement);
    }

    function handleReady() {
        initAttempts = 0;
        initCarousel(document);
    }

    document.addEventListener('shopify:section:load', handleSectionLoad);
    window.addEventListener('resize', handleResize);

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', handleReady, { once: true });
    } else {
        handleReady();
    }

    window.mmProductSlideshowHandlers[sectionId] = {
        teardown: function () {
            document.removeEventListener('shopify:section:load', handleSectionLoad);
            window.removeEventListener('resize', handleResize);
            if (initTimeoutId) {
                window.clearTimeout(initTimeoutId);
                initTimeoutId = null;
            }
        },
    };
};